import React, { useState } from 'react'
import { Backdrop, Button, CircularProgress, useTheme, Typography, Container } from '@mui/material'
import { AddAPhoto } from '@mui/icons-material'

import { FlexDiv } from '../../components'

interface Props {
    index: number
    image: File | null
    setImage: (file: File | null) => void
}

export const ServiceRequestImage = (props: Props) => {
    const { index, image, setImage } = props

    const [loading, setLoading] = useState(false)
    const [fullScreen, setFullScreen] = useState(false)
    const [imageString, setImageString] = useState('')

    const theme = useTheme()

    if (image) {
        const imageFile = image
        const fileReader = new FileReader()
        fileReader.onload = () => {
            const srcData = fileReader.result
            setImageString(String(srcData))
        }
        fileReader.readAsDataURL(imageFile)
    }

    return image ? (
        <FlexDiv>
            <img
                src={imageString}
                style={{
                    height: 100,
                    width: 100,
                    objectFit: 'cover',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.1)',
                }}
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setFullScreen(true)
                }}
            />
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    flexDirection: 'column',
                }}
                open={fullScreen}
                onClick={() => {
                    setFullScreen(false)
                }}
            >
                <img
                    src={imageString}
                    style={{
                        maxHeight: '80%',
                        maxWidth: '100%',
                        borderRadius: '8px',
                    }}
                />
                <Button
                    color="error"
                    style={{
                        flex: 1,
                        maxHeight: 50,
                        marginTop: theme.spacing(2),
                        width: '60%',
                        borderRadius: '8px',
                        textTransform: 'none',
                        backgroundColor: 'rgba(220, 38, 38, 0.8)',
                        color: 'rgba(255,255,255,0.9)',
                        border: '1px solid rgba(220, 38, 38, 0.2)',
                    }}
                    variant="contained"
                    onClick={() => {
                        setImage(null)
                    }}
                >
                    Remove
                </Button>
            </Backdrop>
        </FlexDiv>
    ) : (
        <div>
            <label htmlFor={`icon-button-file_${index}`}>
                <FlexDiv
                    style={{
                        border: '2px dashed rgba(255,255,255,0.1)',
                        width: '100%',
                        height: 100,
                        borderRadius: '8px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        backgroundColor: 'rgba(255,255,255,0.02)',
                        transition: 'all 0.2s ease-in-out',
                        
                    }}
                    
                >
                    {loading ? (
                        <CircularProgress size={24} sx={{ color: 'rgba(255,255,255,0.5)' }} />
                    ) : (
                        <Container
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        >
                        <AddAPhoto sx={{ fontSize: 24, color: 'rgba(255,255,255,0.5)' }} />
                        <Typography variant="body1" color="rgba(255,255,255,0.5)" style={{ marginTop: theme.spacing(1) }}>
                            Upload Photo (optional)
                        </Typography>
                        </Container>
                    )}
                </FlexDiv>
            </label>
            <input
                accept="image/png, image/jpeg, image/jpg"
                id={`icon-button-file_${index}`}
                type="file"
                style={{ display: 'none' }}
                onChange={async (e) => {
                    e.stopPropagation()
                    e.preventDefault()

                    if (e.target.files && e.target.files[0]) {
                        setImage(e.target.files[0])
                        setLoading(false)
                    }
                }}
            />
        </div>
    )
}
